const cycuBuilds = [
  {
    id: 1,
    label: '校門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957287,121.240443',
    position: { lat: 24.957194, lng: 121.240553 },
    entry: { lat: 24.957287, lng: 121.240443 },
    path: './number/cycu-number-1.svg',
  },
  {
    id: 2,
    label: '舊校門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957749,121.240084',
    position: { lat: 24.957749, lng: 121.240084 },
    entry: { lat: 24.957749, lng: 121.240084 },
    path: './number/cycu-number-2.svg',
  },
  {
    id: 3,
    label: '噴水池廣場',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957464,121.240627',
    position: { lat: 24.957464, lng: 121.240627 },
    entry: { lat: 24.957464, lng: 121.240627 },
    path: './number/cycu-number-3.svg',
  },
  {
    id: 4,
    label: '懷恩樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957575,121.240665',
    position: { lat: 24.957647, lng: 121.240676 },
    entry: { lat: 24.957575, lng: 121.240665 },
    path: './number/cycu-number-4.svg',
  },
  {
    id: 5,
    label: '維澈樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956994,121.241131',
    position: { lat: 24.956880, lng: 121.241123 },
    entry: { lat: 24.956994, lng: 121.241131 },
    path: './number/cycu-number-5.svg',
  },
  {
    id: 6,
    label: '行政大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957148,121.241619',
    position: { lat: 24.957104, lng: 121.241661 },
    entry: { lat: 24.957148, lng: 121.241619 },
    path: './number/cycu-number-6.svg',
  },
  {
    id: 7,
    label: '鐘塔',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957123,121.242266',
    position: { lat: 24.957084, lng: 121.242226 },
    entry: { lat: 24.957123, lng: 121.242266 },
    path: './number/cycu-number-7.svg',
  },
  {
    id: 8,
    label: '陸華樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956549,121.241976',
    position: { lat: 24.956328, lng: 121.241924 },
    entry: { lat: 24.956549, lng: 121.241976 },
    path: './number/cycu-number-8.svg',
  },
  {
    id: 9,
    label: '真知教學大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956090,121.241871',
    position: { lat: 24.956090, lng: 121.241871 },
    entry: { lat: 24.956090, lng: 121.241871 },
    path: './number/cycu-number-9.svg',
  },
  {
    id: 10,
    label: '篤信大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956421,121.242607',
    position: { lat: 24.956165, lng: 121.242524 },
    entry: { lat: 24.956421, lng: 121.242607 },
    path: './number/cycu-number-10.svg',
  },
  {
    id: 11,
    label: '電學大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955903,121.242193',
    position: { lat: 24.955894, lng: 121.242458 },
    entry: { lat: 24.955903, lng: 121.242193 },
    path: './number/cycu-number-11.svg',
  },
  {
    id: 12,
    label: '智信樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956559,121.242995',
    position: { lat: 24.956505, lng: 121.243260 },
    entry: { lat: 24.956559, lng: 121.242995 },
    path: './number/cycu-number-12.svg',
  },
  {
    id: 13,
    label: '恩慈樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955379,121.242734',
    position: { lat: 24.955362, lng: 121.242717 },
    entry: { lat: 24.955379, lng: 121.242734 },
    path: './number/cycu-number-13.svg',
  },
  {
    id: 14,
    label: '良善樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955654,121.242328',
    position: { lat: 24.955500, lng: 121.242206 },
    entry: { lat: 24.955654, lng: 121.242328 },
    path: './number/cycu-number-14.svg',
  },
  {
    id: 15,
    label: '建築館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955975,121.243402',
    position: { lat: 24.955746, lng: 121.243420 },
    entry: { lat: 24.955975, lng: 121.243402 },
    path: './number/cycu-number-15.svg',
  },
  {
    id: 16,
    label: '祐生館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955934,121.243739',
    position: { lat: 24.955875, lng: 121.243768 },
    entry: { lat: 24.955934, lng: 121.243739 },
    path: './number/cycu-number-16.svg',
  },
  {
    id: 17,
    label: '機車停車場',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955269,121.244425',
    position: { lat: 24.955437, lng: 121.244437 },
    entry: { lat: 24.955269, lng: 121.244425 },
    path: './number/cycu-number-17.svg',
  },
  {
    id: 18,
    label: '設計學院',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955765,121.244400',
    position: { lat: 24.955704, lng: 121.244554 },
    entry: { lat: 24.955765, lng: 121.244400 },
    path: './number/cycu-number-18.svg',
  },
  {
    id: 19,
    label: '地景建築館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955804,121.244853',
    position: { lat: 24.955525, lng: 121.244849 },
    entry: { lat: 24.955804, lng: 121.244853 },
    path: './number/cycu-number-19.svg',
  },
  {
    id: 20,
    label: '望樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955857,121.245078',
    position: { lat: 24.955694, lng: 121.245135 },
    entry: { lat: 24.955857, lng: 121.245078 },
    path: './number/cycu-number-20.svg',
  },
  {
    id: 21,
    label: '室設館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956118,121.244818',
    position: { lat: 24.956069, lng: 121.245031 },
    entry: { lat: 24.956118, lng: 121.244818 },
    path: './number/cycu-number-21.svg',
  },
  {
    id: 22,
    label: '土木館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956486,121.244434',
    position: { lat: 24.956474, lng: 121.244768 },
    entry: { lat: 24.956486, lng: 121.244434 },
    path: './number/cycu-number-22.svg',
  },
  {
    id: 23,
    label: '莊敬大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956340,121.244400',
    position: { lat: 24.956286, lng: 121.244381 },
    entry: { lat: 24.956340, lng: 121.244400 },
    path: './number/cycu-number-23.svg',
  },
  {
    id: 24,
    label: '工學館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956932,121.244299',
    position: { lat: 24.957341, lng: 121.244518 },
    entry: { lat: 24.956932, lng: 121.244299 },
    path: './number/cycu-number-24.svg',
  },
  {
    id: 25,
    label: '商設館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956798,121.244053',
    position: { lat: 24.956767, lng: 121.243902 },
    entry: { lat: 24.956798, lng: 121.244053 },
    path: './number/cycu-number-25.svg',
  },
  {
    id: 26,
    label: '資管樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957001,121.243463',
    position: { lat: 24.956993, lng: 121.243541 },
    entry: { lat: 24.957001, lng: 121.243463 },
    path: './number/cycu-number-26.svg',
  },
  {
    id: 27,
    label: '管理大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957395,121.243486',
    position: { lat: 24.957468, lng: 121.243498 },
    entry: { lat: 24.957395, lng: 121.243486 },
    path: './number/cycu-number-27.svg',
  },
  {
    id: 28,
    label: '自強商學大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957391,121.243399',
    position: { lat: 24.957583, lng: 121.243839 },
    entry: { lat: 24.957391, lng: 121.243399 },
    path: './number/cycu-number-28.svg',
  },
  {
    id: 29,
    label: '恩惠堂',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957746,121.243306',
    position: { lat: 24.957750, lng: 121.243257 },
    entry: { lat: 24.957746, lng: 121.243306 },
    path: './number/cycu-number-29.svg',
  },
  {
    id: 30,
    label: '化學館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957401,121.242719',
    position: { lat: 24.957489, lng: 121.242737 },
    entry: { lat: 24.957401, lng: 121.242719 },
    path: './number/cycu-number-30.svg',
  },
  {
    id: 31,
    label: '理學大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957422,121.242257',
    position: { lat: 24.957593, lng: 121.242372 },
    entry: { lat: 24.957422, lng: 121.242257 },
    path: './number/cycu-number-31.svg',
  },
  {
    id: 32,
    label: '科學館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957660,121.241808',
    position: { lat: 24.957777, lng: 121.241877 },
    entry: { lat: 24.957660, lng: 121.241808 },
    path: './number/cycu-number-32.svg',
  },
  {
    id: 33,
    label: '張靜愚紀念圖書館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958023,121.240684',
    position: { lat: 24.958285, lng: 121.240684 },
    entry: { lat: 24.958023, lng: 121.240684 },
    path: './number/cycu-number-33.svg',
  },
  {
    id: 34,
    label: '全人教育村',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958714,121.241698',
    position: { lat: 24.958831, lng: 121.242322 },
    entry: { lat: 24.958714, lng: 121.241698 },
    path: './number/cycu-number-34.svg',
  },
  {
    id: 35,
    label: '學生活動中心',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958937,121.241273',
    position: { lat: 24.959011, lng: 121.241016 },
    entry: { lat: 24.958937, lng: 121.241273 },
    path: './number/cycu-number-35.svg',
  },
  {
    id: 36,
    label: '生物科技館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958684,121.240391',
    position: { lat: 24.958944, lng: 121.240330 },
    entry: { lat: 24.958684, lng: 121.240391 },
    path: './number/cycu-number-36.svg',
  },
  {
    id: 37,
    label: '游泳池',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959594,121.241835',
    position: { lat: 24.959430, lng: 121.242208 },
    entry: { lat: 24.959594, lng: 121.241835 },
    path: './number/cycu-number-37.svg',
  },
  {
    id: 38,
    label: '力行大樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959324,121.240911',
    position: { lat: 24.959533, lng: 121.240881 },
    entry: { lat: 24.959324, lng: 121.240911 },
    path: './number/cycu-number-38.svg',
  },
  {
    id: 39,
    label: '體育館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959762,121.242251',
    position: { lat: 24.959972, lng: 121.242429 },
    entry: { lat: 24.959762, lng: 121.242251 },
    path: './number/cycu-number-39.svg',
  },
  {
    id: 40,
    label: '喜樂樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959764,121.240407',
    position: { lat: 24.959783, lng: 121.240460 },
    entry: { lat: 24.959764, lng: 121.240407 },
    path: './number/cycu-number-40.svg',
  },
  {
    id: 41,
    label: '商業設計學系 產品設計組',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959948,121.240386',
    position: { lat: 24.959995, lng: 121.240519 },
    entry: { lat: 24.959948, lng: 121.240386 },
    path: './number/cycu-number-41.svg',
  },
  {
    id: 42,
    label: '忍耐樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960227,121.241390',
    position: { lat: 24.960227, lng: 121.241390 },
    entry: { lat: 24.960227, lng: 121.241390 },
    path: './number/cycu-number-42.svg',
  },
  {
    id: 43,
    label: '和平樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960314,121.241237',
    position: { lat: 24.960324, lng: 121.241102 },
    entry: { lat: 24.960314, lng: 121.241237 },
    path: './number/cycu-number-43.svg',
  },
  {
    id: 44,
    label: '仁愛樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960432,121.241416',
    position: { lat: 24.960472, lng: 121.241423 },
    entry: { lat: 24.960432, lng: 121.241416 },
    path: './number/cycu-number-44.svg',
  },
  {
    id: 45,
    label: '溜冰場',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960568,121.242636',
    position: { lat: 24.960520, lng: 121.242635 },
    entry: { lat: 24.960568, lng: 121.242636 },
    path: './number/cycu-number-45.svg',
  },
  {
    id: 46,
    label: '體育園區',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.961217,121.243527',
    position: { lat: 24.961217, lng: 121.243527 },
    entry: { lat: 24.961217, lng: 121.243527 },
    path: './number/cycu-number-46.svg',
  },
  {
    id: 47,
    label: '薄膜中心（1~3館）',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957914,121.245447',
    position: { lat: 24.957914, lng: 121.245447 },
    entry: { lat: 24.957914, lng: 121.245447 },
    path: './number/cycu-number-47.svg',
  },
  {
    id: 48,
    label: '信實樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959510,121.245885',
    position: { lat: 24.959510, lng: 121.245885 },
    entry: { lat: 24.959510, lng: 121.245885 },
    path: './number/cycu-number-48.svg',
  },
  {
    id: 49,
    label: '水電資設備站',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957530,121.246615',
    position: { lat: 24.957636, lng: 121.246539 },
    entry: { lat: 24.957530, lng: 121.246615 },
    path: './number/cycu-number-49.svg',
  },
  {
    id: 50,
    label: '第一停車場',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957719,121.246214',
    position: { lat: 24.957530, lng: 121.246122 },
    entry: { lat: 24.957719, lng: 121.246214 },
    path: './number/cycu-number-50.svg',
  },
  {
    id: 51,
    label: '污水處理廠',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.961041,121.244980',
    position: { lat: 24.961041, lng: 121.244980 },
    entry: { lat: 24.961041, lng: 121.244980 },
    path: './number/cycu-number-51.svg',
  },
  {
    id: 52,
    label: '新中北淨水廠',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958992,121.246033',
    position: { lat: 24.958994, lng: 121.245984 },
    entry: { lat: 24.958992, lng: 121.246033 },
    path: './number/cycu-number-52.svg',
  },
  {
    id: 53,
    label: '薄膜中心(4館)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958291,121.245368',
    position: { lat: 24.958494, lng: 121.245291 },
    entry: { lat: 24.958291, lng: 121.245368 },
    path: './number/cycu-number-53.svg',
  },
  {
    id: 54,
    label: '熱誠樓(A館)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.961354,121.245312',
    position: { lat: 24.960593, lng: 121.245426 },
    entry: { lat: 24.961354, lng: 121.245312 },
    path: './number/cycu-number-54.svg',
  },
  {
    id: 55,
    label: '熱誠樓(B館)',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960248,121.246208',
    position: { lat: 24.960078, lng: 121.245842 },
    entry: { lat: 24.960248, lng: 121.246208 },
    path: './number/cycu-number-55.svg',
  },
  {
    id: 56,
    label: '智慧領航方舟',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960248,121.246208',
    position: { lat: 24.958811, lng: 121.245625 },
    entry: { lat: 24.960248, lng: 121.246208 },
    path: './number/cycu-number-56.svg',
  },
  {
    id: 57,
    label: '知行領航館',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958523,121.245953',
    position: { lat: 24.958732, lng: 121.246179 },
    entry: { lat: 24.958523, lng: 121.245953 },
    path: './number/cycu-number-57.svg',
  },
  {
    id: 58,
    label: '實英樓',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957733,121.245632',
    position: { lat: 24.957733, lng: 121.245632 },
    entry: { lat: 24.957278, lng: 121.240523 },
    path: './number/cycu-number-58.svg',
  },
  {
    id: 59,
    label: 'A1 正門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957278,121.240523',
    position: { lat: 24.957153, lng: 121.240264 },
    entry: { lat: 24.957278, lng: 121.240523 },
    path: './number/cycu-number-A1.svg',
  },
  {
    id: 60,
    label: 'A2 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955680,121.241704',
    position: { lat: 24.955695, lng: 121.241653 },
    entry: { lat: 24.955680, lng: 121.241704 },
    path: './number/cycu-number-A2.svg',
  },
  {
    id: 61,
    label: 'A3 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955371,121.243171',
    position: { lat: 24.955284, lng: 121.243248 },
    entry: { lat: 24.955371, lng: 121.243171 },
    path: './number/cycu-number-A3.svg',
  },
  {
    id: 62,
    label: 'A4 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.955737,121.243994',
    position: { lat: 24.955603, lng: 121.243904 },
    entry: { lat: 24.955737, lng: 121.243994 },
    path: './number/cycu-number-A4.svg',
  },
  {
    id: 63,
    label: 'A5 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.956964,121.244796',
    position: { lat: 24.956655, lng: 121.244974 },
    entry: { lat: 24.956964, lng: 121.244796 },
    path: './number/cycu-number-A5.svg',
  },
  {
    id: 64,
    label: 'A6 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958185,121.243780',
    position: { lat: 24.958294, lng: 121.243938 },
    entry: { lat: 24.958185, lng: 121.243780 },
    path: './number/cycu-number-A6.svg',
  },
  {
    id: 65,
    label: 'A7 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959129,121.241521',
    position: { lat: 24.959287, lng: 121.241511 },
    entry: { lat: 24.959129, lng: 121.241521 },
    path: './number/cycu-number-A7.svg',
  },
  {
    id: 66,
    label: 'A8 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957915,121.240151',
    position: { lat: 24.957963, lng: 121.239957 },
    entry: { lat: 24.957915, lng: 121.240151 },
    path: './number/cycu-number-A8.svg',
  },
  {
    id: 67,
    label: 'B1 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.959418,121.241629',
    position: { lat: 24.959317, lng: 121.241747 },
    entry: { lat: 24.959418, lng: 121.241629 },
    path: './number/cycu-number-B1.svg',
  },
  {
    id: 68,
    label: 'B2 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960911,121.244466',
    position: { lat: 24.960911, lng: 121.244466 },
    entry: { lat: 24.960911, lng: 121.244466 },
    path: './number/cycu-number-B2.svg',
  },
  {
    id: 69,
    label: 'C1 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.957628,121.245581',
    position: { lat: 24.957456, lng: 121.245841 },
    entry: { lat: 24.957628, lng: 121.245581 },
    path: './number/cycu-number-C1.svg',
  },
  {
    id: 70,
    label: 'C2 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960723,121.245798',
    position: { lat: 24.960978, lng: 121.245846 },
    entry: { lat: 24.960723, lng: 121.245798 },
    path: './number/cycu-number-C2.svg',
  },
  {
    id: 72,
    label: 'C3 門',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.960926,121.244936',
    position: { lat: 24.960794, lng: 121.244928 },
    entry: { lat: 24.960926, lng: 121.244936 },
    path: './number/cycu-number-C3.svg',
  },
  // {
  //   id: 73,
  //   label: 'C4 門',
  //   url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958025,121.245035',
  //   position: { lat: 24.957882, lng: 121.244899 },
  //   entry: { lat: 24.958025, lng: 121.245035 },
  //   path: './number/cycu-number-C4.svg',
  // },
  {
    id: 73,
    label: '性別友善廁所',
    url: 'https://www.google.com/maps?saddr=My+Location&daddr=24.958899,121.242219',
    position: { lat: 24.958899, lng: 121.242219 },
    entry: { lat: 24.958899, lng: 121.242219 },
    path: './number/cycu-number-WC.svg',
  },
];

export default cycuBuilds;
